"use client"

import { ViewTracker } from "~/components/web/view-tracker"

export type ToolViewedProperties = {
  slug: string
  category: string | null
  tags: string[]
  tool_name: string
  is_featured: boolean
  is_published: boolean
}

export function ToolViewTracker({
  properties,
}: Readonly<{
  properties: ToolViewedProperties
}>) {
  return (
    <ViewTracker
      eventName="marketing.tool_viewed"
      logScope="tools"
      properties={properties}
      trackingKey={properties.slug}
    />
  )
}
